<template>
    <div>
      <TopBar />
      <el-container>
        <el-aside width="200px">
          <SideBar />
        </el-aside>
        <el-main>
            <div class="main" style="width: 100%;;height: 1100px;overflow-y: hidden;;background: #e8e8e8;;display: flex;flex-direction: row;width: 100%;padding: 20px;">
                <div class="left" style="display: flex;flex-direction: column;width: 50%;height: 100%;">
                    <div class="Course-info" style="height: 65%;margin: 10px;background: #ffffff;">
                        <p class="title-div">课程信息</p>
                        <div class="bar" style="border: 1px solid #f0f2f6;width:90%;margin-left: 5%;"></div>
                        <p style="color: #1f63ff;font-size: 30px;font-weight: 600;margin: 0;margin-left: 15px;">接 口 技 术</p>
                        <p style="margin:10px;letter-spacing: 2px;">《接口技术》介绍了微型计算机的基本原理与常用接口的设计方法。主要内容包括微处理器结构、指令系统、存储器接口、输入/输出接口、中断技术、常用可编程接口芯片及其应用、人机交互接口以及总线技术。</p>
                        <div style="width: 100%;display: flex;flex-direction: row;">
                            <div style="width: 33.33%;">
                                <p style="text-align: center;color: #1f63ff;font-size: 20px;font-weight: 600;">课程学分</p>
                                <p style="text-align: center;font-weight: 600;font-size: 18px;">2.5</p>
                            </div>
                            <div style="width: 33.33%;">
                                <p style="text-align: center;color: #1f63ff;font-size: 20px;font-weight: 600;">课程性质</p>
                                <p style="text-align: center;font-weight: 600;font-size: 18px;">专业主干课</p>
                            </div>
                            <div style="width: 33.33%;">
                                <p style="text-align: center;color: #1f63ff;font-size: 20px;font-weight: 600;">课堂数量</p>
                                <p style="text-align: center;font-weight: 600;font-size: 18px;">3</p>
                            </div>
                        </div>
                        <div class="bar" style="border: 1px solid #f0f2f6;width:90%;margin-left: 5%;"></div>
                        <div class="bottom1" id="all-classes" style="flex-direction: column;display: flex;justify-content: center;align-items: center;">
                            <div class="title1">
                                <div class="class-info">
                                    <p style="color: #1f63ff;font-size: 20px;font-weight: 600;">授课老师</p>
                                </div>
                                <div class="class-info">
                                    <p style="color: #1f63ff;font-size: 20px;font-weight: 600;">上课地点</p>
                                </div>
                                <div class="class-info">
                                    <p style="color: #1f63ff;font-size: 20px;font-weight: 600;">上课时间</p>
                                </div>
                                <div class="class-info">
                                    <p style="color: #1f63ff;font-size: 20px;font-weight: 600;">上课人数</p>
                                </div>
                                </div>
                                <div v-for="(classInfo, index) in classData" :key="index" class="all-classes">
                                    <div class="class-info">
                                        <p>{{ classInfo.teacher }}</p>
                                    </div>
                                    <div class="class-info" style="display: flex;flex-direction: column;margin: 0;">
                                        <div v-for="(locationinfo, locationIndex) in classInfo.location.split(',')" :key="locationIndex">
                                            <p style="margin: 10px;">{{ locationinfo.trim() }}</p>
                                        </div>
                                    </div>
                                    <div class="class-info" style="display: flex;flex-direction: column;margin: 0;">
                                        <div v-for="(time, timeIndex) in classInfo.times.split(',')" :key="timeIndex">
                                            <p style="margin: 10px;">{{ time.trim() }}</p>
                                        </div>
                                    </div>
                                    <div class="class-info">
                                        <p>{{ classInfo.count }}</p>
                                    </div>
                            </div>
                        </div>
                    </div>
                    <div class="course-mode" style="height:40%;margin: 10px;background: #ffffff;">
                        <p class="title-div">课程模式</p>
                        <div style="width: 100%;height: 90%;display: flex;flex-direction: row;">
                            <div style="width: 50%;height: 100%;text-align: center;">
                                <p><span style="color: #4ed6ff;font-size: 50px;font-weight: 600;">67%</span><span style="color: #9a9a9a;font-size: 25px;font-weight: 600;">讲授型</span></p>
                                <p><span style="color: #4ed6ff;font-size: 50px;font-weight: 600;">52%</span><span style="color: #9a9a9a;font-size: 25px;font-weight: 600;">混合型</span></p>
                                <p><span style="color: #4ed6ff;font-size: 50px;font-weight: 600;">43%</span><span style="color: #9a9a9a;font-size: 25px;font-weight: 600;">对话型</span></p>
                                <p><span style="color: #4ed6ff;font-size: 50px;font-weight: 600;">17%</span><span style="color: #9a9a9a;font-size: 25px;font-weight: 600;">联系型</span></p>
                            </div>
                            <div class="radar-grapgic" style="display: flex;width: 50%;height: 100%;justify-content: center;align-items: center;">
                                <ClassMode />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="right" style="width: 60%;height: 100%;display: flex;flex-direction: column;">
                    <div class="homework-finish" style="height: 33%;margin: 10px;background: #ffffff;">
                        <p class="title-div">学生作业完成情况</p>
                        <div style="display: flex;flex-direction: row;">
                            <div class="left-homework" style="width: 50%;display: flex;justify-content: center;align-items: center;">
                                <table style="width: 100%;;margin-left: 10px;font-size: 10px;text-align: center;border-collapse: collapse;padding: 0;">
                                    <tr style="width: 100%;height: 40px;border-bottom: 1px solid #e5e8ef; background: #f2f3f8;">
                                        <th style="width: 15%;font-size: 13px;padding-bottom: 3px;">排名</th>
                                        <th style="width: 40%;font-size: 13px;padding-bottom: 3px;">姓名</th>
                                        <th style="width: 45%;font-size: 13px;padding-bottom: 0px;">作业综合评价</th>
                                    </tr>
                                    <tr style="width: 100%;height: 40px;border-bottom: 1px solid #e5e8ef;">
                                        <td style="width: 15%;">1</td>
                                        <td style="width: 40%;">张三</td>
                                        <td style="width: 45%;">99.62</td>
                                    </tr>
                                    <tr style="width: 100%;height: 40px;border-bottom: 1px solid #e5e8ef;">
                                        <td style="width: 15%;">2</td>
                                        <td style="width: 40%;">张三</td>
                                        <td style="width: 45%;">98.42</td>
                                    </tr>
                                    <tr style="width: 100%;height: 40px;border-bottom: 1px solid #e5e8ef;">
                                        <td style="width: 15%;">3</td>
                                        <td style="width: 40%;">张三</td>
                                        <td style="width: 45%;">96.17</td>
                                    </tr>
                                    <tr style="width: 100%;height: 30px;border-bottom: 1px solid #e5e8ef;">
                                        <td style="width: 15%;">……</td>
                                        <td style="width: 40%;"></td>
                                        <td style="width: 45%;color: #3270ff;cursor: pointer;">查看更多</td>
                                    </tr>
                                </table>
                            </div>
                            <div style="margin-left: 10px;text-align: center;">
                                <p><span class="name-color">王*楚</span> 提交了作业</p>
                                <p><span class="name-color">海*</span> 老师批改了 <span class="name-color">王*楚</span> 的作业</p>
                                <p><span class="name-color">王*楚</span> 提交了作业</p>
                                <p><span class="name-color">王*楚</span> 提交了作业</p>
                                <p>……</p>
                            </div>
                        </div>
                    </div>
                    <div class="course-resourse" style="height:33%;margin: 10px;background: #ffffff;">
                        <p class="title-div">课程资源占比</p>
                        <div style="height: 100%;width: 100%;display: flex;flex-direction: row;">
                            <div class="left-resource" style="height: 100%;width: 55%;display: flex;justify-content: center;align-items: center;">
                                <resorce-ration-vue></resorce-ration-vue>
                            </div>
                            <div class="right-resource" style="height: 90%;">
                                <ul style="margin-bottom: 30px;">
                                    <li>
                                    <img src="../../public/images/文档color.png" alt="文档">
                                    <div class="resource-text" style="">
                                        <p style="color: #9a9a9a;">文档 8.5GB</p>
                                        <p>76692</p>
                                    </div>
                                    </li>
                                    <li>
                                    <img src="../../public/images/视频color.png" alt="视频">
                                    <div class="resource-text">
                                        <p style="color: #9a9a9a;">视频 10.2GB</p>
                                        <p>148</p>
                                    </div>
                                    </li>
                                
                                    <li>
                                    <img src="../../public/images/图片color.png" alt="图片">
                                    <div class="resource-text">
                                        <p style="color: #9a9a9a;">图片 13.2GB</p>
                                        <p>96</p>
                                    </div>
                                    </li>
                                    <li>
                                    <img src="../../public/images/作业color.png" alt="作业">
                                    <div class="resource-text">
                                        <p style="color: #9a9a9a;">作业/测验</p>
                                        <p>1535</p>
                                    </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        
                    </div>
                    <div class="platform-use" style="height:33%;margin: 10px;background: #ffffff;">
                        <p class="title-div">平台使用情况（近七日）</p>
                        <PlatUseVue></PlatUseVue>
                    </div>
                </div>
            </div>
        </el-main>
      </el-container>
    </div>
</template>
<script>
import PlatUseVue from '@/components/PlatUse.vue';
import SideBar from '../components/SideBar.vue';
import TopBar from '../components/TopBar.vue';
import ResorceRationVue from '@/components/ResorceRation.vue';
import ClassMode from '@/components/ClassMode.vue';
export default {
  name: 'HomePage',
  components: { SideBar, TopBar, PlatUseVue, ResorceRationVue,ClassMode },
  data() {
    return {
      classData: [
        {
          teacher: '姚华雄',
          location: 'n112, n533',
          times: '星期一 第1-2节, 星期二 第3-4节',
          count: '23人'
        },{
          teacher: '姚华雄',
          location: 'n112, n533',
          times: '星期一 第1-2节, 星期二 第3-4节',
          count: '23人'
        },{
          teacher: '姚华雄',
          location: 'n112, n533',
          times: '星期一 第1-2节, 星期二 第3-4节',
          count: '23人'
        },
        // ... 更多课程数据
      ]
    };
  }
};
</script>

<style scoped>
    .name-color {
    color: #3270ff; /* 学生名字颜色 */
    }
    .all-classes {
    width: 90%;
    display: flex;
    flex-direction: row;
    border-radius: 20px;
    border: 2px solid gray;
    margin-bottom: 10px;
  }
  .title1{
    width: 90%;
    display: flex;
    flex-direction: row;
  }
  .class-info {
    width: 25%;
    text-align: center;
    justify-content: center;
    align-items: center;
    display: flex;
  }
  .title-div{
    font-size: 20px;
    font-weight: 600;
    margin: 0;
    margin-left: 10px;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .right-resource ul > li {
  margin: 0px;
  margin-right: 0;
  flex-direction: row; /* 子元素水平排列 */
  height: 80px;
  width: 150px;
  display: flex;
  
}

.right-resource ul > li > img {
  margin: 5px;
  height: 40px;
  width: 40px;  
  object-fit: cover;
  /* margin-bottom: 20px; */
}
</style>